export const guessLocale = () => {
  return navigator.language || 'en-US';
}
export const  guessDateFormat = () => {
  const userLocale = guessLocale();

  const dateTimeFormat = new Intl.DateTimeFormat(userLocale);

  const formatParts = dateTimeFormat.formatToParts(new Date());

  const dateFormat = formatParts.map(part => {
      switch (part.type) {
          case 'day':
              return 'DD';
          case 'month':
              return 'MM';
          case 'year':
              return 'YYYY';
          default:
              return part.value;
      }
  }).join('');

  return dateFormat;
}


export const guessTimeFormat = () => {
  const userLocale = navigator.language || 'en-US';

  const dateTimeFormat = new Intl.DateTimeFormat(userLocale, { hour: 'numeric' });

  const formattedTime = dateTimeFormat.format(new Date(2025, 0, 1, 13, 0)); // 1 PM

  const is12HourFormat = formattedTime.toLowerCase().includes('am') || formattedTime.toLowerCase().includes('pm');

  return is12HourFormat ? '12-hour' : '24-hour';
}